import { transformDateValue } from 'core/js/FormUtils';
export const getInventoryView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let inventoryList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Product Id","fieldValue":transformDataValue(data.productid,"bodynamiclist"), "fieldType":"bodynamiclist"},
                            {"fieldLabel":"Product Name","fieldValue":transformDataValue(data.productname,"string"), "fieldType":"string"},
                            {"fieldLabel":"Item Count","fieldValue":transformDataValue(data.itemcount,"number"), "fieldType":"number"},
                            {"fieldLabel":"Order Id","fieldValue":transformDataValue(data.orderid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Product Order Id","fieldValue":transformDataValue(data.productorderid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Credit Item Id","fieldValue":transformDataValue(data.credititemid,"ID"), "fieldType":"ID"},
              
              
            ],
            'dataList': [
                
              ]
          }

          inventoryList.push(card);
  })
  return inventoryList;
}